import React from 'react';
import RenderError from '../../components/RenderError';

function AdditionalBasicInfoFields({
  two,
  unit,
  handleInputChange,
  equipmentType,
  formData,
  setFormData,
  errors
}) {
  return (
    <>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="fuelType"
        >
          Fuel Type
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].fuelType} />
        )}
        <label className="form__radio">
          <input
            type="radio"
            name={`fuelType${two ? '2' : '1'}`}
            value="Propane"
            checked={
              two
                ? formData.unitTwo.fuelType2 === 'Propane'
                  ? 'checked'
                  : ''
                : formData.unitOne.fuelType1 === 'Propane'
                ? 'checked'
                : ''
            }
            onChange={(event) => handleInputChange(event, two)}
          />
          Propane
        </label>
        <label className="form__radio">
          <input
            type="radio"
            name={`fuelType${two ? '2' : '1'}`}
            value="Dual Fuel"
            checked={
              two
                ? formData.unitTwo.fuelType2 === 'Dual Fuel'
                  ? 'checked'
                  : ''
                : formData.unitOne.fuelType1 === 'Dual Fuel'
                ? 'checked'
                : ''
            }
            onChange={(event) => handleInputChange(event, two)}
          />
          Dual Fuel
        </label>
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="engineSize">
          Engine Size (liters):{' '}
        </label>
        <input
          type="number"
          name="engineSize"
          step=".01"
          value={formData[unit].engineSize}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].engineSize} />
        )}
      </div>
    </>
  );
}

export default AdditionalBasicInfoFields;
